export default __webpack_public_path__ + "static/media/sftdev.bd8dba57.png";